import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AppActions from '../../../AppActions';
import { history } from "../../../store";

 class Contact extends Component {

  render() {
    return (
      <div className="view">
        {
          this.props.language.map != null ? 
            <div style={{marginTop:"2em"}} className="offset-xl-2 offset-lg-2 offset-md-1 col-xl-8 col-lg-8 col-md-10 col-sm-11 col-xs-12">
              <div style={{textAlign:"center"}}>
                <button style={{marginTop:"50px", marginBottom: "2em"}}className="btn btn-outline-primary" onClick={(e) => this.props.history.goBack()}>{this.props.language.map.labels.common.back}</button>
              </div> 
              <h4>{this.props.language.map.header.contact.header1}</h4>
              <div className="row">
                <div className="col-6">
                  <ul style={{listStyleType: "none", paddingLeft:"0"}}>
                    <li>{this.props.language.map.static.imprint.address.company}</li>
                    <li>{this.props.language.map.static.imprint.address.street}</li>
                    <li>{this.props.language.map.static.imprint.address.zip}&nbsp;{this.props.language.map.static.imprint.address.city}</li>
                    <li>{this.props.language.map.static.imprint.address.country}</li>
                    <li>Fon: {this.props.language.map.static.imprint.address.phone}</li>
                    <li>Fax: {this.props.language.map.static.imprint.address.fax}</li>
                    <li>Email: <a href={"mailto:" + this.props.language.map.static.imprint.address.email}>{this.props.language.map.static.imprint.address.email}</a></li>
                    <li><a href={"https://www.abci.de"}>{"https://www.abci.de"}</a></li>
                  </ul>                
                </div> 
                <div className="col-6 d-flex flex-column justify-content-center align-items-center">
                  <img src="/s/logo.png" width="100%"/>
                </div>                
              </div>
              <div style={{textAlign:"center"}}>
                <button style={{marginTop:"50px", marginBottom: "2em"}}className="btn btn-outline-primary" onClick={(e) => this.props.history.goBack()}>{this.props.language.map.labels.common.back}</button>
              </div>  
            </div>
            :
            null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
   router: state.routerReducer,
   language: state.application.language
});

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(AppActions.goBack())
})

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/modules/contact/view/Contact.js